const RESTORE_SETTLE_TIMEOUT = 800;

export interface PageScrollPosition {
  pageLeft: number;
  pageTop: number;
  windowLeft: number;
  windowTop: number;
}

const getPageContainer = () =>
  document.querySelector<HTMLElement>(".app-layout__page");

export const getPageScrollPosition = (): PageScrollPosition => {
  const pageContainer = getPageContainer();

  return {
    pageLeft: pageContainer?.scrollLeft ?? 0,
    pageTop: pageContainer?.scrollTop ?? 0,
    windowLeft:
      window.pageXOffset || document.documentElement.scrollLeft || 0,
    windowTop:
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0,
  };
};

const applyScrollPosition = (position: PageScrollPosition) => {
  if (typeof window.scrollTo === "function") {
    window.scrollTo({
      behavior: "auto",
      left: position.windowLeft,
      top: position.windowTop,
    });
  }

  const pageContainer = getPageContainer();
  if (!pageContainer) return;

  if (typeof pageContainer.scrollTo === "function") {
    pageContainer.scrollTo({
      behavior: "auto",
      left: position.pageLeft,
      top: position.pageTop,
    });
  } else {
    pageContainer.scrollLeft = position.pageLeft;
    pageContainer.scrollTop = position.pageTop;
  }
};

const isPositionRestored = (position: PageScrollPosition) => {
  const current = getPageScrollPosition();

  return (
    Math.abs(current.windowTop - position.windowTop) <= 1 &&
    Math.abs(current.windowLeft - position.windowLeft) <= 1 &&
    Math.abs(current.pageTop - position.pageTop) <= 1 &&
    Math.abs(current.pageLeft - position.pageLeft) <= 1
  );
};

/**
 * Restaura imediatamente e repete por um curto período caso a rota ainda
 * esteja montando conteúdo assíncrono e o navegador limite a posição inicial.
 */
const scrollPageToPosition = (position: PageScrollPosition) => {
  let frame = 0;
  const startedAt = Date.now();

  const cancel = () => {
    if (frame) window.cancelAnimationFrame(frame);
    window.removeEventListener("wheel", cancel);
    window.removeEventListener("touchstart", cancel);
    window.removeEventListener("pointerdown", cancel);
  };

  const ensurePosition = () => {
    applyScrollPosition(position);

    if (
      isPositionRestored(position) ||
      Date.now() - startedAt >= RESTORE_SETTLE_TIMEOUT ||
      typeof window.requestAnimationFrame !== "function"
    ) {
      cancel();
      return;
    }

    frame = window.requestAnimationFrame(ensurePosition);
  };

  window.addEventListener("wheel", cancel, { passive: true });
  window.addEventListener("touchstart", cancel, { passive: true });
  window.addEventListener("pointerdown", cancel, { passive: true });
  ensurePosition();

  return cancel;
};

export default scrollPageToPosition;
